import React from "react";
import PropTypes from "prop-types";
import { css } from "@emotion/react";
import Link from "../../shared/Link/Link";
import styled from "@emotion/styled";
import { theme } from "../../../utils/global-styles/theme";
import RightGoToArrow from "../../CourseCard/Icons/RightGoToArrow";
import {
  determineProductPath,
  determineProductType,
} from "../../../utils/services/methods";

const SingleColumnCard = ({
  languageCode = "en-US",
  slug,
  title,
  cta,
  courseCost,
  courseDuration,
  courseType,
  courseAvailability,
  gridColumnValue,
  backgroundColorClass,
  courseIcon,
  shortDescription,
}) => {
  const SingleCardWrapper = styled(Link)`
      grid-area: 1 / ${gridColumnValue} / span 1 / span 1;
      height: 360px;
      padding: 50px;
      display: grid;
      grid-template: 32px 3fr 1fr / 20% 80%;
      transition: 0.2s ease-in-out;
      > .card-show-hover {
        display: none;
      }
      &:hover {
        cursor: pointer;

        > .card-show-hover {
          display: flex;
        }
        > .card-hide-hover {
          display: none;
        }
      }
    `,
    SingleCardCourseTypeIconWrapper = styled("div")`
      display: flex;
      justify-content: center;
      align-items: flex-start;
      grid-area: 2 / 1 / span 1;
      margin-right: 35px;
    `,
    SingleCardCourseTypeText = styled("p")`
      font-size: 1em;
      font-weight: normal;
      font-family: ${theme.fontFaces.headers};
      grid-area: 1 / 2 / span 1;
      display: flex;
      align-items: flex-start;
    `,
    SingleCardDetailsWrapper = styled("div")`
      grid-area: 3 / 2 / span 1;
      display: flex;
      align-self: end;
      flex-direction: row;
      justify-content: left;
      p {
        border-top-width: 4px;
        border-top-style: solid;
        padding-top: 9px;
        margin-right: 30px;
        font-size: 13px;
        line-height: 16px;
        font-family: ${theme.fontFaces.headers};
        font-weight: bold;
        text-transform: capitalize;

        &:last-child {
          margin-right: 0px;
        }
      }
    `,
    SingleCardCourseDetailsText = styled("p")`
      grid-area: 2 / 2 / span 1 / span 1;
      font-size: 20px;
      line-height: 31px;
      font-weight: normal;
    `,
    CourseCtaWrapper = styled("div")`
      grid-area: 3 / 2 / span 1 / span 2;
      align-self: end;
      align-items: center;
      display: flex;
      flex-direction: row;
    `,
    CourseCtaIcon = styled("p")`
      padding-left: 3px;
      &:hover {
        color: ${theme.colors.main};
      }
    `,
    CourseCtaText = styled("p")`
      color: ${theme.colors.white};
      font-family: ${theme.fontFaces.headers};
      font-size: 13px;
      font-weight: bold;
      line-height: 31px;
      padding-bottom: 5px;
    `,
    type = determineProductType(courseType),
    to = cta?.url || determineProductPath(type, languageCode, slug);

  return (
    <SingleCardWrapper
      className={`mrkt-course-card ${backgroundColorClass}`}
      to={`${to}`}
    >
      <SingleCardCourseTypeText
        className={` ${
          backgroundColorClass === "course-catalog-primary-single-card"
            ? "white"
            : "main"
        }`}
      >
        {courseType}
      </SingleCardCourseTypeText>
      <h2
        className="card-hide-hover"
        css={css`
          grid-area: 2 / 2 / span 1 / span 1;
          font-size: 1.8em;
          line-height: 42px;
          letter-spacing: -0.91px;
        `}
      >
        {title}
      </h2>
      <SingleCardCourseDetailsText className="card-show-hover">
        {shortDescription.shortDescription}
      </SingleCardCourseDetailsText>
      <SingleCardDetailsWrapper className="card-hide-hover">
        <p className={"black-border main"}>{courseCost}</p>
        <p
          className={
            backgroundColorClass === "course-catalog-primary-single-card"
              ? "white-border"
              : "black-border main"
          }
        >
          {courseAvailability}
        </p>
        <p
          className={
            backgroundColorClass === "course-catalog-primary-single-card"
              ? "white-border"
              : "black-border main"
          }
        >
          {courseDuration}
        </p>
      </SingleCardDetailsWrapper>
      <CourseCtaWrapper className="card-show-hover">
        <CourseCtaText>{cta?.linkText || "Enroll Now"}</CourseCtaText>
        <CourseCtaIcon>
          <RightGoToArrow
            fillColor={
              backgroundColorClass === "course-catalog-primary-single-card"
                ? "white-fill"
                : "main-fill"
            }
          />
        </CourseCtaIcon>
      </CourseCtaWrapper>
    </SingleCardWrapper>
  );
};

SingleColumnCard.propTypes = {
  slug: PropTypes.string,
  title: PropTypes.string,
  shortDescription: PropTypes.shape({ shortDescription: PropTypes.string }),
  courseCost: PropTypes.string,
  courseDuration: PropTypes.string,
  courseType: PropTypes.string,
  courseAvailability: PropTypes.string,
  gridColumnValue: PropTypes.string,
  backgroundColorClass: PropTypes.string,
  courseIcon: PropTypes.element,
};

export default SingleColumnCard;
